import {useSessionStore} from '~/modules/shared/composables/stores/SessionStore';
import {exportUserSession} from '~/modules/shared/composables/utils/Helpers';

export default defineNuxtRouteMiddleware(async (to) => {
  const useSession = useSessionStore();
  const config = useRuntimeConfig();

  if (
    config.public.sessionTimeoutRedirectURL !== to.path &&
    to.path !== '/access-code' &&
    to.path !== '/access-code/auth' &&
    to.path !== '/generate-error' &&
    to.path !== '/notification-settings'
  ) {
    const cookie = exportUserSession();
    if (cookie.value === undefined || cookie.value === null) {
      await useSession.timeout();
    }
  }
});
